import React, { FC } from "react";
import StepList from "../ReviewSummary/components/InstructionsList/StepList";
import { StepsProps } from "./types";
import Step from "../ReviewSummary/components/InstructionsList/Step";

const Steps: FC<StepsProps> = ({ steps }) => {
  return (
    <StepList>
      {steps.map((step, i) => (
        <Step key={i} {...step} />
      ))}
    </StepList>
  );
};

export default Steps;
